import casesView from './cases';
import caseView from './case';
import homeView from './home';
import teamView from './team';

export default [homeView, casesView, caseView, teamView];